// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Router from "next/router";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as AuthUtils$PorterinFeature from "../../../domain/helpers/AuthUtils.mjs";
import * as AuthHelper$PorterinFeature from "../../../domain/helpers/AuthHelper.mjs";
import * as AuthTextCmp$PorterinFeature from "../common/AuthTextCmp.mjs";
import * as CityContext$PorterinFeature from "../../../../../contexts/city-context/CityContext.mjs";
import * as AuthButtonCmp$PorterinFeature from "../common/AuthButtonCmp.mjs";
import * as AuthContextV1$PorterinFeature from "../../../view-model/contexts/auth-context/AuthContextV1.mjs";
import * as CategoryAnalytics$PorterinFeature from "../../../../fare-estimate-v1/domain/helpers/CategoryAnalytics.mjs";
import * as CommonAnalyticsHelper$PorterinFeature from "../../../../../shared/core/helpers/CommonAnalyticsHelper.mjs";
import * as RequirementSelectionVm$PorterinFeature from "../../../view-model/RequirementSelectionVm.mjs";
import * as SignupReqSelectionCardCmp$PorterinFeature from "./SignupReqSelectionCardCmp.mjs";
import * as SignupReqSelectionModuleScss from "../../styles/SignupReqSelection.module.scss";

var styles = SignupReqSelectionModuleScss;

function SignupReqSelectionCmp(Props) {
  var set_auth_state = Props.set_auth_state;
  var match = React.useState(function () {
        
      });
  var setRequirement = match[1];
  var requirement = match[0];
  var match$1 = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var match$2 = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var set_user = match$2.set_user;
  var user = match$2.user;
  var router = Router.useRouter();
  React.useEffect((function () {
          var timeout_id = setTimeout((function (param) {
                  CommonAnalyticsHelper$PorterinFeature.publishPageLandEvent(CategoryAnalytics$PorterinFeature.getCategoryName(router), AuthStore$PorterinFeature.SignupRequirement.ga_page_landing);
                }), 0);
          return (function (param) {
                    clearTimeout(timeout_id);
                  });
        }), []);
  return React.createElement("div", {
              className: styles.wrapper
            }, React.createElement("div", {
                  className: styles["requirement-wrapper"]
                }, React.createElement(AuthTextCmp$PorterinFeature.make, {
                      heading: AuthStore$PorterinFeature.SignupRequirement.requirement_heading,
                      sub_heading: undefined
                    }), React.createElement("div", {
                      className: styles["label-required"]
                    }, AuthStore$PorterinFeature.SignupRequirement.requirement_subheading), React.createElement("div", {
                      className: styles.requirement
                    }, RequirementSelectionVm$PorterinFeature.requirement_selection.map(function (card_data, index) {
                          return React.createElement(SignupReqSelectionCardCmp$PorterinFeature.make, {
                                      card_data: card_data,
                                      requirement: requirement,
                                      click_handler: (function (param) {
                                          Curry._1(setRequirement, (function (param) {
                                                  return card_data.requirement;
                                                }));
                                        }),
                                      key: String(index)
                                    });
                        }))), React.createElement("div", {
                  className: styles["submit-button"],
                  onClick: (function (param) {
                      Curry._1(set_user, {
                            auth_token: undefined,
                            mobile: AuthUtils$PorterinFeature.mobile(user),
                            name: AuthUtils$PorterinFeature.name(user),
                            requirement_type: AuthHelper$PorterinFeature.requirementTypeToString(requirement),
                            email: AuthUtils$PorterinFeature.email(user),
                            whatsapp_consent: AuthUtils$PorterinFeature.whatsappConsent(user)
                          });
                      Curry._1(set_auth_state, (function (param) {
                              return /* OtpValidation */2;
                            }));
                    })
                }, React.createElement(AuthButtonCmp$PorterinFeature.make, {
                      is_disabled: Belt_Option.isNone(requirement),
                      class_name: "submit-button",
                      event_name: AuthStore$PorterinFeature.SignupRequirement.ga_form_submit_event,
                      category: match$1.category,
                      submit_text: AuthStore$PorterinFeature.SignupRequirement.submit_button,
                      event_label: AuthHelper$PorterinFeature.requirementTypeToString(requirement),
                      mobile: AuthUtils$PorterinFeature.mobile(user)
                    })));
}

var make = SignupReqSelectionCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
